import React from "react";
import ReactDOM from "react-dom";
import "styles/index.css";
import App from "./pages/_app";
import reportWebVitals from "./reportWebVitals";
import Providers from "components/Providers";
import {Router} from "react-router-dom";
import {browserHistory} from "services/utils/redirect";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
function Index() {
  return (
    <Router history={browserHistory}>
      <Providers>
        <App />
      </Providers>
    </Router>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
